var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Fleece & Sherpa Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Fleece & Sherpa Line",
      "file": "fleece"
    }
  }, [_vm._v(" 단/장 섬유의 셰르파와 폴라 플리스, 밍크 플리스, 테리 플리스, 벨루어, 브러쉬드 니트 등. 합성, 혼방 섬유 셰르파와 플리스 원단에 풍부한 경험을 가지며, 특히 뛰어난 품질과 가격을 만나보실 수 있습니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }